"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var valid = _a.valid;
            return ({
                width: '100% !important',
                height: '100% !important',
                borderColor: valid === false ? 'red !important' : undefined,
                padding: 8,
                margin: 0,
                '& > input': {
                    border: 'none !important',
                    outline: 'none !important',
                    padding: 0,
                    margin: 0,
                }
            });
        }
    });
});
